import * as turf from '@turf/turf';
import axios from 'axios';

export const reverseGeocode = async (lat: number, lng: number) => {
  const apiKey = import.meta.env.VITE_GOOGLE_API_KEY;
  const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;

  try {
    const response = await axios.get(url);
    const results = response.data.results;

    if (results.length > 0) {
      // Prioritize address_components for locality, admin area, or country
      const firstResult = results[0];
      const components = firstResult.address_components;

      const locationParts = [];
      // Extract desired components
      for (const component of components) {
        if (
          component.types.includes('locality') || // City
          component.types.includes('administrative_area_level_1') || // State
          component.types.includes('country') // Country
        ) {
          locationParts.push(component.long_name);
        }
      }

      // Join parts to form a readable address
      return locationParts.join(', ');
    } else {
      return 'Unknown Location'; // Fallback if no results are found
    }
  } catch (error) {
    console.error('Error reverse geocoding:', error);
    return 'Error fetching location';
  }
};

// Get the center from a bounding box
export const getCenterFromBBox = (bbox: number[]) => {
  if (bbox.length !== 4) {
    throw new Error(
      'BBox must have exactly 4 elements: [minLat, maxLat, minLng, maxLng]'
    );
  }
  // Convert [minLat, maxLat, minLng, maxLng] to [minLng, minLat, maxLng, maxLat] cuz turf expects this
  const [minLat, maxLat, minLng, maxLng] = bbox;
  const reorderedBBox: [number, number, number, number] = [
    minLng,
    minLat,
    maxLng,
    maxLat
  ];
  const polygon = turf.bboxPolygon(reorderedBBox);
  const centroid = turf.centroid(polygon);

  const [lng, lat] = centroid.geometry.coordinates;

  return { lat, lng };
};
